import { Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React, { useContext } from 'react'
import { Context } from '../WithdrawSummary';
import { WithdrawStatusCell, getWithdrawRowStatus } from './withdrawStatus';

export const InternalTableRow = (props) => {
  const { value, user, createdAt, id } = props;
  const status = getWithdrawRowStatus(props)

  const { dispatch } = useContext(Context);

  const datedString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const _handleUndo = () => {
    const c = window.confirm(`Chắc chắn hoàn giao dịch này? ` + id)
    if (c) {
      dispatch({
        type: 'UNDO',
        payload: id
      })
    }
  }

  return (
    <tr className='text-center'>
      <td>
        {status.reverted ? null : (
          <Button variant="danger" className="m-1" onClick={_handleUndo}>Thu hồi</Button>
        )}
      </td>
      <td>
        {(user && user.name) || ""}<br />
        <span ><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
      </td>
      <td className={`align-items-right ${status.reverted ? 'text-danger' : ''}`}>{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <WithdrawStatusCell {...props} />
      <td>{datedString}</td>
    </tr>
  );
};
